import { combineReducers } from "redux";
import rules from './rules';
import filters from './filters';

export default combineReducers({ rules, filters });